import { MilestoneParams } from '@/backend/access/milestone/types';

export class Milestone {
  id: string;
  name: string;
  description?: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  projectId: string;
  propelOrgId: string;
  dueDate?: string;
  
  get title(): string {
    return this.name;
  }

  constructor(params: MilestoneParams) {
    this.id = params.id;
    this.name = params.name;
    this.description = params.description;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.projectId = params.projectId;
    this.propelOrgId = params.propelOrgId;
    this.dueDate = params.dueDate;
  }
}
